export const mutations = {
  UPDATE_EOI (state, payload) {
    Object.assign(state, payload);
  },
  UPDATE_ADDITIONAL_POSTCODE_FIELDS (state) {
    state.ua_tradingaddresspostcode = state.ua_tradingaddresspostcode;
    state.ua_registeredaddresspostcode = state.ua_registeredaddresspostcode;
  },
  UPDATE_CURRENT_STEP (state, payload) {
    state.ua_currentpageinapplication = payload;
  }
};
